import { useDeepCompareEffect } from '@oscar/utils';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTableContext } from '../../hooks';
import {
  getCommitedByKeySelector,
  getLoadingByKeySelector,
} from '../../selectors';
import { ActionProps, Request } from '../../typed';

const ActionButton: FC<ActionProps> = ({
  children,
  uniqueKey,
  onResponseData,
  onLoading,
  hotReload,
}) => {
  const [tableContext] = useTableContext();

  const getCommitedByKey = getCommitedByKeySelector(tableContext.options!.name);

  const responseData = uniqueKey
    ? useSelector((state) => getCommitedByKey(state, uniqueKey))
    : undefined;
  const getLoadingByKey = getLoadingByKeySelector(tableContext.options!.name);
  const isLoading = uniqueKey
    ? useSelector((state) => getLoadingByKey(state, uniqueKey))
    : undefined;

  const doAction = useCallback(
    (request: Request, data: any) => {
      tableContext?.doAction?.(
        {
          ...request,
          name: uniqueKey ? `${uniqueKey}.${request.name}` : request.name,
        },
        data
      );
    },
    [uniqueKey, tableContext]
  );

  useDeepCompareEffect(() => {
    if (uniqueKey && responseData) {
      if (hotReload) {
        tableContext?.fetchData?.();
      } else if (onResponseData) {
        onResponseData?.(responseData);
      }
    }
  }, [uniqueKey, responseData]);

  useDeepCompareEffect(() => {
    if (onLoading && uniqueKey) {
      onLoading?.(isLoading);
    }
  }, [uniqueKey, isLoading]);

  return typeof children === 'function'
    ? children({
        doAction,
        fetchData: tableContext.fetchData,
      })
    : null;
};

export default ActionButton;
